import React, { FC } from 'react';
import { QRCode } from 'react-qrcode-logo';
import { Button, Collapse, Form, Input } from 'antd';
import { apiMessagesGetFormRules } from '../../../middleware';
import { Catcher } from '../../Catcher';
import ViewStyles from '../../styles/m_viewStyles.less';

const { Panel } = Collapse;

type IEnable2FAForm2 = {
    provisioningUri?: string;
};

export const Form2FAQRCode: FC<IEnable2FAForm2> = ({ provisioningUri }: IEnable2FAForm2) => {
    // ToDo: 26.05.2025 -  add translate
    return (
        <Catcher>
            <div className={ViewStyles.text}>
                <p>
                    1. To add 2-Step Authentication with the Authenticator app, you need to have the application
                    installed.{' '}
                </p>
            </div>
            <Collapse>
                <Panel key={1} header={'Android'}>
                    <div className={ViewStyles.collapsePanel}>
                        <div className={ViewStyles.qrItem}>
                            <Button
                                href={
                                    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=web_share'
                                }
                                type={'link'}
                                target={'_blank'}
                            >
                                Google Authenticator
                            </Button>
                            <QRCode
                                value={
                                    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=web_share'
                                }
                                ecLevel={'L'}
                            />
                        </div>
                        <div className={ViewStyles.qrItem}>
                            <Button
                                href={
                                    'https://play.google.com/store/apps/details?id=com.azure.authenticator&pcampaignid=web_share'
                                }
                                type={'link'}
                                target={'_blank'}
                            >
                                Microsoft Authenticator
                            </Button>
                            <QRCode
                                value={
                                    'https://play.google.com/store/apps/details?id=com.azure.authenticator&pcampaignid=web_share'
                                }
                                ecLevel={'L'}
                            />
                        </div>
                    </div>
                </Panel>
                <Panel key={2} header={'iOS'}>
                    <div className={ViewStyles.collapsePanel}>
                        <div className={ViewStyles.qrItem}>
                            <Button
                                href={'https://apps.apple.com/us/app/google-authenticator/id388497605'}
                                type={'link'}
                                target={'_blank'}
                            >
                                Google Authenticator
                            </Button>

                            <QRCode
                                value={'https://apps.apple.com/us/app/google-authenticator/id388497605'}
                                ecLevel={'L'}
                            />
                        </div>
                        <div className={ViewStyles.qrItem}>
                            <Button
                                href={'https://apps.apple.com/us/app/microsoft-authenticator/id983156458'}
                                type={'link'}
                                target={'_blank'}
                            >
                                Microsoft Authenticator
                            </Button>
                            <QRCode
                                value={'https://apps.apple.com/us/app/microsoft-authenticator/id983156458'}
                                ecLevel={'L'}
                            />
                        </div>
                    </div>
                </Panel>
            </Collapse>
            <div className={ViewStyles.text}>
                <p>2. Scan the QR code using the Authenticator app.</p>
                {provisioningUri ? <QRCode value={provisioningUri || '-'} ecLevel={'L'} /> : 'NotCode'}
                <p>3. Enter the Time-based One-time Password displayed in you Authenticator app.</p>
            </div>
            <Form.Item name="secretWord" label={'TOTP'} rules={apiMessagesGetFormRules}>
                <Input placeholder={'TOTP'} />
            </Form.Item>
        </Catcher>
    );
};
